import { SlotRepository } from '../Repositories/SlotRepository';
import { CheckSlotsExistsRequest, CheckSlotsExistsResponse } from '../../Model/Slot';

export class CheckSlotsExistsUseCase {
  constructor(private repo: SlotRepository) {}
  execute(request: CheckSlotsExistsRequest): Promise<CheckSlotsExistsResponse> {
    if (!request.slot_ids.length) {
      return Promise.resolve({ existing_ids: [], missing_ids: [] });
    }
    return this.repo.checkExists(request);
  }
}
